import { Box, Flex } from '@chakra-ui/react';

import { CloseIcon } from 'Asset/icon';
import InputComponent from 'UiKit/input';
import RichTextEditor from 'UiKit/rich-text';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';
import ButtonOutline from 'UiKit/button/buttonOutline';

const TITLE_MAX_LENGTH = 225;

const BriefSectionCard = ({ section, error, isFetching, register, onChangeDescription, sectionsLength, onRemove, t }) => {
  const isDeleteDisabled = sectionsLength <= 4;
  return (
    <Box className={styles['brief-section-card__container']}>
      <Flex className={styles['brief-section-card__title--row']}>
        <Box className={styles['brief-section-card__title--input-wrapper']}>
          <InputComponent
            placeholder={t("formTalkingPoint.sectionTitlePlaceholderText")}
            value={section?.title}
            error={error?.title}
            isFetching={isFetching}
            isRequired
            register={register}
          />
          <TextRegular className={styles['brief-section-card__char--counter']}>
            ({section?.title?.length || 0}/{TITLE_MAX_LENGTH})
          </TextRegular>
        </Box>
        <Box className={styles['brief-section-card__delete--container']}>
          <ButtonOutline
            color={isDeleteDisabled ? 'var(--color-semantic-text-disabled)' : 'var(--color-error50)'}
            width="32px"
            height="32px"
            isDisabled={isDeleteDisabled}
            onClick={onRemove}
          >
            <CloseIcon />
          </ButtonOutline>
        </Box>
      </Flex>
      <RichTextEditor
        value={section?.description}
        onChange={onChangeDescription}
        placeholder={t("formTalkingPoint.sectionDescriptionPlaceholderText")}
        error={!!error?.description}
        errorMessage={error?.description?.message}
      />
    </Box>
  );
};

export default BriefSectionCard;
